import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useEffect } from 'react';
import { getPosScaleProfileList } from '@store/Sales/Pos/posScaleSlice';

export const SelectProfileScale = ({ value, onChange }: any) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { profiles, loadingProfiles, errorProfiles } = useAppSelector(state => state.posScale);

  useEffect(() => {
    dispatch(getPosScaleProfileList());
  }, [dispatch]);

  const options = profiles?.map(item => ({ value: item.id, label: i18n.language === 'en' ? item.name : item.name2 }));

  return (
    <Select
      classNamePrefix='react-select'
      isLoading={loadingProfiles}
      isSearchable={true}
      isClearable
      options={options}
      value={options?.find(f => f.value === value)}
      onChange={onChange}
      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
    />
  );
};
